import { ComponentEvents } from "global/interfaces/component.interface";

export const MoleculeInputSearchFatEvents: ComponentEvents = {
	search: 'searchEvent'
}

export interface MoleculeInputSearchFatEvent {
	searchValue: string;
}
